import { api } from './request'
import type {
  LoginRequest,
  RegisterRequest,
  SendCodeRequest,
  AuthResponse,
  User,
} from '@/types'

export interface UpdateProfileRequest {
  username?: string
  display_name?: string
  bio?: string
  website?: string
  company?: string
  location?: string
  avatar?: string
}

export interface ChangePasswordRequest {
  current_password: string
  new_password: string
}

export const authApi = {
  // Send verification code
  sendCode(data: SendCodeRequest) {
    return api.post('/send-code', data)
  },
  
  // Register
  register(data: RegisterRequest) {
    return api.post<AuthResponse>('/register', data)
  },
  
  // Login
  login(data: LoginRequest) {
    return api.post<AuthResponse>('/login', data)
  },
  
  // GitHub auth URL
  getGitHubAuthUrl() {
    return api.get<{ auth_url: string; state: string }>('/github/auth')
  },
  
  // GitHub callback (handled by redirect)
  githubCallback(code: string) {
    return api.get<AuthResponse>(`/github/callback?code=${code}`)
  },
  
  // Get profile
  getProfile() {
    return api.get<User>('/profile')
  },
  
  // Update profile
  updateProfile(data: UpdateProfileRequest) {
    return api.put<User>('/profile', data)
  },
  
  // Change password
  changePassword(data: ChangePasswordRequest) {
    return api.put('/profile/password', data)
  },
  
  // Upload avatar
  uploadAvatar(formData: FormData) {
    return api.upload('/profile/avatar', formData)
  },
  
  // Reset password
  resetPassword(data: { email: string; code: string; new_password: string }) {
    return api.post('/reset-password', data)
  },
  
  // Access tokens
  listTokens() {
    return api.get<any[]>('/tokens')
  },
  createToken(data: { name: string; scopes: string[] }) {
    return api.post<{ id: number; name: string; token: string; scopes: string[]; created_at: string }>('/tokens', data)
  },
  deleteToken(id: number) {
    return api.delete(`/tokens/${id}`)
  },
}

export default authApi